<template>
  <div class="c-sortable-item" @click="$emit('click')">
    <slot></slot>
    <div class="c-sortable-item__controls">
      <base-button
        square
        @click="$emit('moveUp')"
        title="Move item up"
        :disabled="!enabled"
        >&uarr;<span class="screen-reader-text">Move item up</span></base-button
      >
      <base-button
        square
        @click="$emit('moveDown')"
        title="Move item down"
        :disabled="!enabled"
        >&darr;
        <span class="screen-reader-text">Move item down </span></base-button
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "SortableItem",
  props: {
    enabled: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.c-sortable-item {
  padding: 10px;
  border-bottom: 1px solid $colour-nhs-pale-grey;
  cursor: move;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &__controls {
    button {
      padding: 10px;
    }
  }
}
</style>
